import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-portal-organizational-services',
  templateUrl: './portal-organizational-services.component.html',
  styleUrls: ['./portal-organizational-services.component.scss', './portal-organizational-services.component.en.scss']
})
export class PortalOrganizationalServices {
  @Input() data: any;
}
